export default "__VITE_ASSET__59b8ccb1__"